export const ANALYSIS_TABLE_TYPE_OPTIONS = [
    { value: "OVERVIEW_TOTAL", label: "Overview total" },
    { value: "OVERVIEW_PERCENT", label: "Overview percent" },
    { value: "MTTR", label: "Mean time to resolve" },
    { value: "CASES_PER_DAY", label: "Daily cases" },
];

export const DEFAULT_ANALYSIS_TABLE_TYPE = "OVERVIEW_TOTAL";